import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  AUTODISPLAY_ACTIVE_HTML,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_ACTIVE_DPI_INFO,
  AUTODISPLAY_INTERVER_TIME,
  AUTODISPLAY_EDU_VIEW_DESIGN_CONCEPT,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_TITLE,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_MARKDOWN,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_JSON,
  AUTODISPLAY_EDU_VIEW_CONTENTS_PURPOSE,
  AUTODISPLAY_EDU_VIEW_CONTENTS_TYPE,
  IS_DESKTOP_SCALE,
} from "../../../AtomStates";
import { useAtom } from "jotai";
import {
  viewCheckActivateStateEduRequest,
  viewCheckUpdateStateEduRequest,
} from "../../../../utils/indexedDB";
import MoleculeBackgroundModern from "../../../CreateEducationContentPage/components/molecules/MoleculeBackgroundModern";
import MoleculeBackgroundSimple from "../../../CreateEducationContentPage/components/molecules/MoleculeBackgroundSimple";
import MoleculeBackgroundSimpleWide from "../../../CreateEducationContentPage/components/molecules/MoleculeBackgroundSimpleWide";
import MoleculeMenuBoard from "../../../CreateEducationContentPage/components/molecules/MoleculeMenuBoard";

const OrganismDisplayViewerEdu = ({
  path,
  activateCode,
  activateTimestamp,
}) => {
  const [autoDisplayActiveDPIInfo] = useAtom(AUTODISPLAY_ACTIVE_DPI_INFO);
  const [autoDisplaySelectedDevice] = useAtom(AUTODISPLAY_SELECTED_DEVICE);
  const [autodisplayIntervalTime] = useAtom(AUTODISPLAY_INTERVER_TIME);
  const [loading, setLoading] = useState(true);
  const [contentSize, setContentSize] = useState({ width: 1200, height: 800 });
  const [viewData, setViewData] = useState(null);
  const [autoDisplayEduViewDesignConcept, setAutoDisplayEduViewDesignConcept] =
    useAtom(AUTODISPLAY_EDU_VIEW_DESIGN_CONCEPT);
  const [autoDisplayEduViewContentsType, setAutoDisplayEduViewContentsType] =
    useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_TYPE);
  const [
    autoDisplayEduViewContentGeneratorTitle,
    setAutoDisplayEduViewContentGeneratorTitle,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_TITLE);
  const [
    autoDisplayEduViewContentGeneratorMarkdown,
    setAutoDisplayEduViewContentGeneratorMarkdown,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_MARKDOWN);
  const [
    autoDisplayEduViewContentGeneratorJson,
    setAutoDisplayEduViewContentGeneratorJson,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_JSON);

  const [isDesktopScale] = useAtom(IS_DESKTOP_SCALE);
  const [
    autoDisplayEduViewContentsPurpose,
    setAutoDisplayEduViewContentsPurpose,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_PURPOSE);

  useEffect(() => {
    const checkActivateState = async () => {
      try {
        const response = await viewCheckActivateStateEduRequest({
          viewId: path,
          activateCode,
          activateTimestamp: activateTimestamp,
          activateCheckTimestamp: Date.now(),
        });
        console.log("checkActivateState", response);
        if (response && response.status === "nonActivate") {
          window.location.href = "/AutodisplayViewEdu";
        }
      } catch (error) {
        console.error(error);
        window.location.href = "/AutodisplayViewEdu";
      }
    };

    const checkUpdateState = async () => {
      try {
        const response = await viewCheckActivateStateEduRequest({
          viewId: path,
          activateCode,
          activateTimestamp: activateTimestamp,
        });
        console.log("checkUpdateState", response);

        // 응답이 success인 경우 데이터 업데이트
        if (response && response.status === "success") {
          // 데이터 업데이트
        }
      } catch (error) {
        console.error(error);
      }
    };

    // 초기 실행
    checkActivateState();
    checkUpdateState();

    // 10분마다 반복 실행
    const interval = setInterval(() => {
      checkActivateState();
      checkUpdateState();
    }, autodisplayIntervalTime);

    // 컴포넌트 언마운트 시 인터벌 정리
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (
      autoDisplayEduViewContentGeneratorTitle ||
      autoDisplayEduViewContentGeneratorJson
    ) {
      setLoading(true);

      // Google Fonts 로드
      const link = document.createElement("link");
      link.href =
        "https://fonts.googleapis.com/css2?family=Pretendard:wght@400;600;700&display=swap";
      link.rel = "stylesheet";
      if (!document.querySelector(`link[href="${link.href}"]`)) {
        document.head.appendChild(link);
      }

      setLoading(false);
    }
  }, [
    autoDisplayEduViewContentGeneratorTitle,
    autoDisplayEduViewContentGeneratorJson,
  ]);

  // 로딩 상태
  if (loading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
        <LoadingText>콘텐츠를 불러오는 중...</LoadingText>
        {/* <LoadingSubText>HTML을 가져와 파싱하고 있습니다</LoadingSubText> */}
      </LoadingContainer>
    );
  }

  return (
    <FullScreenContainer>
      {/* {autoDisplayActiveHTML && ( */}
      <>
        {/* {autoDisplayEduViewDesignConcept === "모던 게시판형" && (
          <ComponentContainer>
            <MoleculeBackgroundModern
              contentsPurpose={autoDisplayEduViewContentsPurpose}
              title={
                Array.isArray(autoDisplayEduViewContentGeneratorJson?.title)
                  ? autoDisplayEduViewContentGeneratorJson.title.join("\n")
                  : autoDisplayEduViewContentGeneratorJson?.title
              }
              content={
                autoDisplayEduViewContentGeneratorJson ? (
                  <StyledContentContainerForModern>
                    <StyledMainDescription>
                      {autoDisplayEduViewContentGeneratorJson.description}
                    </StyledMainDescription>
                    <StyledThickLine />
                    {autoDisplayEduViewContentGeneratorJson.sections?.map(
                      (section, index) => (
                        <React.Fragment key={index}>
                          <StyledSectionRow>
                            <StyledSectionTitle>
                              {section.section_title}
                            </StyledSectionTitle>
                            <StyledSectionContent>
                              {Array.isArray(section.section_content) ? (
                                section.section_content.map((line, index) => (
                                  <StyledBulletItem key={index}>
                                    - {line}
                                  </StyledBulletItem>
                                ))
                              ) : (
                                <StyledBulletItem>
                                  - {section.section_content}
                                </StyledBulletItem>
                              )}
                            </StyledSectionContent>
                          </StyledSectionRow>
                          {index <
                          autoDisplayEduViewContentGeneratorJson.sections
                            .length -
                            1 ? (
                            <StyledThinLine />
                          ) : (
                            <StyledThickLine />
                          )}
                        </React.Fragment>
                      )
                    )}
                  </StyledContentContainerForModern>
                ) : null
              }
            />
          </ComponentContainer>
        )}
        {autoDisplayEduViewDesignConcept === "심플 플로우형" && (
          <ComponentContainer>
            <MoleculeBackgroundSimpleWide
              contentsDesignConcept={autoDisplayEduViewDesignConcept}
              title={autoDisplayEduViewContentGeneratorTitle}
              content={autoDisplayEduViewContentGeneratorMarkdown}
            />
          </ComponentContainer>
        )} */}
        {autoDisplayEduViewContentsType === "meal" && (
          <ComponentWrapper isDesktopScale={isDesktopScale}>
            <ComponentContainer isDesktopScale={isDesktopScale}>
              <MoleculeMenuBoard
                backgroundImage={
                  autoDisplayEduViewContentGeneratorJson.backgroundImage
                }
                menuData={autoDisplayEduViewContentGeneratorJson}
                noticeText={autoDisplayEduViewContentGeneratorJson.noticeText}
              />
            </ComponentContainer>
          </ComponentWrapper>
        )}
        <ComponentWrapper isDesktopScale={isDesktopScale}>
          <ComponentContainer isDesktopScale={isDesktopScale}>
            <MoleculeBackgroundSimpleWide
              contentsDesignConcept={autoDisplayEduViewDesignConcept}
              title={autoDisplayEduViewContentGeneratorTitle}
              content={autoDisplayEduViewContentGeneratorMarkdown}
            />
          </ComponentContainer>
        </ComponentWrapper>
      </>
      {/* )} */}
    </FullScreenContainer>
  );
};

export default OrganismDisplayViewerEdu;

// 스타일 컴포넌트들
const FullScreenContainer = styled.div`
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: white;
  overflow: hidden; /* 스크롤 완전 제거 */
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
`;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  z-index: 9999;
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #333;
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.div`
  color: black;
  font-size: 18px;
  font-weight: 600;
`;

const LoadingSubText = styled.div`
  color: #666;
  font-size: 14px;
  text-align: center;
`;

// 실제 차지하는 공간을 조정하는 wrapper
const ComponentWrapper = styled.div`
  width: ${(props) => (props.isDesktopScale ? "1920px" : "3840px")};
  height: ${(props) => (props.isDesktopScale ? "1080px" : "2160px")};
  overflow: hidden;
  margin: 0 auto;
`;

const ComponentContainer = styled.div`
  width: 3840px;
  height: 2160px;
  /* margin: 20px auto; */
  background: white;
  position: relative;
  overflow: visible; /* 스케일링된 콘텐츠가 잘리지 않도록 설정 */

  /* 뷰포트 크기에 맞게 스케일링 */
  transform-origin: top left;

  ${(props) =>
    props.isDesktopScale
      ? `
        transform: scale(0.5); /* 데스크탑에서 1/2 크기로 축소 */
        @media (max-width: 4000px) {
          transform: scale(0.5);
        }
      `
      : `
        transform: scale(min(calc(100vw / 3840), calc(100vh / 2160)));
        @media (max-width: 4000px) {
          transform: scale(min(calc((100vw - 40px) / 3840), calc((100vh - 100px) / 2160)));
        }
      `}
`;

const StyledMainDescription = styled.span`
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledThickLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 3px black solid;
  outline-offset: -2px;
`;

const StyledSectionTitle = styled.span`
  width: 144px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledSectionContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledBulletItem = styled.div`
  width: 688px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
  padding-left: 32px;
  text-indent: -22px;
`;

const StyledThinLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 1px black solid;
  outline-offset: 0px;
`;

const StyledSectionRow = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: inline-flex;
`;

const StyledContentContainerForModern = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;
